<nav aria-label="breadcrumb" class="breadcrumb-nav border-0 mb-0">
    <div [class]="'d-flex align-items-center ' + (fullWidth ? 'container-fluid' : 'container')">
        <ol class="breadcrumb" itemscope itemtype="https://schema.org/BreadcrumbList">
            <li class="breadcrumb-item"
                itemprop="itemListElement" itemscope
                itemtype="https://schema.org/ListItem">
                <a itemprop="item" routerLink="/">
                    <span itemprop="name">Home</span></a>
                <meta itemprop="position" content="1" />
            </li>
            <li class="breadcrumb-item"
                itemprop="itemListElement" itemscope
                itemtype="https://schema.org/ListItem">
                <a itemprop="item" routerLink="/shop">
                    <span itemprop="name">Product</span></a>
                    <meta itemprop="position" content="2" />
            </li>
            <li class="breadcrumb-item active"
                itemprop="itemListElement" itemscope
                itemtype="https://schema.org/ListItem">
                    <span itemprop="name">{{ current }}</span>
                    <meta itemprop="position" content="3" />
            </li>
        </ol>

        <nav class="product-pager ml-auto" aria-label="Product">
            <a [routerLink]="['../' + prev.slug]" class="product-pager-link product-pager-prev"
                [class]="{'prev-only': !next}" *ngIf="prev">
                <i class="icon-angle-left"></i>
                <span>Prev</span>
                <div class="product-detail">
                    <figure class="overflow-hidden">
                        <molla-image [src]="prev.sm_pictures[0].url" alt="Product" class="product-image">
                        </molla-image>
                    </figure>
                    <h3 class="product-name">{{ prev.name }}</h3>
                </div>
            </a>

            <a [routerLink]="['../' + next.slug]" class="product-pager-link product-pager-next" *ngIf="next">
                <span>Next</span>
                <i class="icon-angle-right"></i>
                <div class="product-detail">
                    <figure class="overflow-hidden">
                        <molla-image [src]="next.sm_pictures[0].url" alt="Product" class="product-image">
                        </molla-image>
                    </figure>
                    <h3 class="product-name">{{ next.name }}</h3>
                </div>
            </a>
        </nav>
    </div>
</nav>